<template>
    <div class="app-container">
        <div class="record-container">
            <pang-title :text="$router.lang.get('商  城')" eng="Store"/>
            <pang-tab
            :tabs="tabs" v-model:current="currentTab"/>
            <div class="butt-tab-container">
                <pang-tab
                :tabs="buttTabs" v-model:current="currentButtTab" styleType="butt"/>
                <div v-if="!isCollapse" class="search-container">
                    <pang-date v-model:startDate="startDate" v-model:endDate="endDate"/>
                    <pang-butt @click="search" :text="$router.lang.get('搜索')" :style="{marginLeft: '14px', padding: '0', width: '65px'}" :loading="loading"/>
                </div>
            </div>
            <div class="table-container">
                <pang-table v-if="currentButtTab==0" :ths="isCollapse?rechargeThs.slice(0, 4):rechargeThs" :rows="rechargeRecords" @rowclick="rowClick"/>
                <pang-table v-else :ths="isCollapse?propThs.slice(0, 5):propThs" :rows="propRecords"/>
            </div>
            <div class="pager-container">
                <pang-pager v-if="totalPages > 1" @change="goto" :totalPages="totalPages" :currentPage="currentPage"/>
            </div>
        </div>
        <pang-dialog v-if="showingItem" :title="$router.lang.get('儲值記錄')" :cancelText="$router.lang.get('取消')" :submitText="$router.lang.get('確認')" @cancel="cancel" @submit="cancel">
            <div class="record-detail" :class="isCollapse?'detail-collapse':''">
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('訂單編號：') }}</div>
                    <div>{{ showingItem.record_num }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('狀態：') }}</div>
                    <div>{{ showingItem.status }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('商品：') }}</div>
                    <div>{{ showingItem.product_name }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('價格：') }}</div>
                    <div>{{ showingItem.priceFormated }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('登錄日：') }}</div>
                    <div>{{ showingItem.create_at }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('當前點數：') }}</div>
                    <div>{{ priceFormat(showingItem.current_point) }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('支付途徑：') }}</div>
                    <div>{{ showingItem.payment_method }}</div>
                </div>
                <div class="detail-item">
                    <div class="detail-label">{{ $router.lang.get('交易號：', {payment_method: showingItem.payment_method}) }}</div>
                    <div>{{ showingItem.trade_seq }}</div>
                </div>
            </div>
        </pang-dialog>
    </div>
</template>

<script>

import { useScreenState } from '../../store';
import request from '../../api/request'
import filters from '../../utils/filters'
import enums from '../../utils/enums'
import { PangTitle, PangTab, PangDate, PangTable, PangPager, PangDialog, PangButt } from '../../components'
import message from '../../utils/message'

const pathTabMapping = [
    '/shop/point',
    '/shop/prop',
    '/shop/record',
]

export default {
    name: 'Record',
    components: {
        PangTitle,
        PangTab,
        PangDate,
        PangTable,
        PangPager,
        PangDialog,
        PangButt,
    },
    data () {
        return {
            loading: false,
            screenState: useScreenState(),
            currentTab: 2,
            currentButtTab: 0,
            endDate: filters.dateFormat(new Date()).slice(0, 10),
            startDate: '',
            totalPages: 1,
            currentPage: 1,
            showingItem: null,
            tabs: [
                this.$router.lang.get('儲值點數'),
                this.$router.lang.get('購買元寶'),
                this.$router.lang.get('購買記錄'),
            ],
            buttTabs: [
                this.$router.lang.get('儲值記錄'),
                this.$router.lang.get('消費記錄'),
            ],
            rechargeThs: [
                {
                    label: this.$router.lang.get('訂單編號'),
                    field: 'record_num',
                    width: '32.5%',
                },
                {
                    label: this.$router.lang.get('狀態'),
                    field: 'status',
                    width: '8%',
                },
                {
                    label: this.$router.lang.get('商品'),
                    field: 'product_name',
                    width: '19.2%',
                },
                {
                    label: this.$router.lang.get('價格'),
                    field: 'priceFormated',
                    width: '19.2%',
                },
                {
                    label: this.$router.lang.get('登錄日'),
                    field: 'create_at',
                    width: '21.1%',
                },
            ],
            rechargeRecords: [
            ],
            propThs: [
                {
                    label: this.$router.lang.get('使用點數'),
                    field: 'point',
                    width: '25%',
                },
                {
                    label: this.$router.lang.get('當前點數'),
                    field: 'current_point',
                    width: '25%',
                },
                {
                    label: this.$router.lang.get('商品名'),
                    field: 'product_name',
                    width: '25%',
                },
                {
                    label: this.$router.lang.get('登錄日'),
                    field: 'create_at',
                    width: '',
                },
            ],
            propRecords: [
            ],
        };
    },
    watch: {
        currentTab(val) {
            this.$router.replace(pathTabMapping[val])
        },
        currentButtTab() {
            this.currentPage = 1
            this.refresh()
        }
    },
    computed: {
        isCollapse() {
        return this.screenState.screenWidth < 900;
        },
    },
    methods: {
        priceFormat: filters.priceFormat,
        search () {
            this.startDateConfirm = this.startDate
            this.endDateConfirm = this.endDate
            this.currentPage = 1
            this.refresh()
        },
        goto (page) {
            this.currentPage = page
            this.refresh()
        },
        getParams () {
            let params = {
                limit: 10,
                page: this.currentPage,
                user_id: this.screenState.user.id,
            }
            if (this.startDateConfirm) {
                params['create_at__gte'] = this.startDateConfirm + ' 00:00:00'
            }
            if (this.endDateConfirm) {
                let endDate = new Date(this.endDateConfirm.replace('-', '/'))
                endDate.setDate(endDate.getDate() + 1)
                params['create_at__lt'] = filters.dateFormat(endDate)
            }
            return params
        },
        getRecharges () {
            let params = this.getParams()
            params.status__in = '2,3,4,5'
            let _this = this
            request.get('/rechargerecords', params, this).then(function (res) {
                if (res.status == 200) {
                    _this.totalPages = res.data.paging.total_pages
                    _this.rechargeRecords = res.data.results.map(function (x) {
                        x.priceFormated = 'THB$' + filters.priceFormat(x.price)
                        x.create_at = x.create_at.slice(0, 19)
                        x.status = enums.RECHARGE_STATUS[x.status]
                        return x
                    })
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        getProps () {
            let params = this.getParams()
            let _this = this
            request.get('/proprecords', params, this).then(function (res) {
                if (res.status == 200) {
                    _this.totalPages = res.data.paging.total_pages
                    _this.propRecords = res.data.results.map(function (x) {
                        x.current_point = filters.priceFormat(x.current_point)
                        x.point = filters.priceFormat(x.point)
                        x.create_at = x.create_at.slice(0, 19)
                        return x
                    })
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        refresh () {
            if (this.currentButtTab == 0)
                this.getRecharges()
            else
                this.getProps()
        },
        rowClick (row) {
            this.showingItem =  row
            let _this = this
            request.get('/rechargerecords/' + row.id, {}, this).then(function (res) {
                if (res.status == 200) {
                    _this.showingItem.status = enums.RECHARGE_STATUS[res.data.status]
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        showDetail (id) {
            if (id) {
            let _this = this
                request.get('/rechargerecords/' + id, {}, this).then(function (res) {
                    if (res.status == 200) {
                        if (_this.$route.query.isnew) {
                            // window.fbq('track', 'Purchase', {currency: "TWD", value: res.data.price});
                            _this.$router.replace({ path: '/shop/record', query: { id: _this.$route.query.id }})
                            request.get('/users/me', {}).then(function (res) {
                                if (res.status == 200) {
                                    _this.screenState.user = res.data
                                    window.localStorage.setItem(
                                    "user_info",
                                    JSON.stringify(res.data)
                                    );
                                }
                                else if (res.status == 404) {
                                    window.localStorage.removeItem('token')
                                    window.localStorage.removeItem('user_info')
                                    _this.$router.push('/account/login')
                                }
                            })
                        }
                        _this.showingItem = res.data
                        _this.showingItem.priceFormated = 'THB$' + filters.priceFormat(_this.showingItem.price)
                        _this.showingItem.create_at = _this.showingItem.create_at.slice(0, 19)
                        _this.showingItem.status = enums.RECHARGE_STATUS[_this.showingItem.status]
                    }
                    else {
                        message.resMessage(res, _this)
                    }
                })
            }
        },
        cancel () {
            this.showingItem = null
        }
    },
    mounted () {
        if (this.screenState.user) {
            this.refresh()
            if (this.$route.query.id) {
                this.showDetail(parseInt(this.$route.query.id))
                let _this = this
                request.get('/users/me', {}, this).then(function (res) {
                    if (res.status == 200) {
                        window.localStorage.setItem('user_info', JSON.stringify(res.data))
                        _this.screenState.user = res.data
                    }
                    else if (res.status == 404) {
                        window.localStorage.removeItem('token')
                        window.localStorage.removeItem('user_info')
                        _this.$router.push('/account/login')
                    }
                })
            }
        }
    },
}
</script>

<style scoped>

.record-container {
    max-width: 1042px;
    width: 90vw;
    margin: auto;
    color: #939393;
    margin-bottom: 100px;
}

.butt-tab-container {
    margin-top: 40px;
    display: flex;
}
.search-container {
    display: flex;
    margin-left: auto;
    margin-right: 0;
}

.search-butt {
    width: 65px;
    line-height: 38px;
    background: linear-gradient(132deg, #C6A86C 0%, #E0CDA5 100%);
    border-radius: 19px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 14px;
    cursor: pointer;
}

.table-container {
    margin-top: 50px;
    margin-bottom: 50px;
}

.record-detail {
    margin: 35px 0;
    line-height: 32px;
}

.detail-collapse {
    font-size: 3vw;
}

.record-detail > div:last-child {
    word-break: normal;
}

.detail-item {
    display: flex;
}

.detail-label {
    width: 30%;
}
</style>
